/**
 * Inicializa o Ionic Core (só componentes visuais + navegação) e registra
 * apenas os componentes usados, para o bundle ficar pequeno.
 */
import { initialize } from '@ionic/core/components';
import { addIcons } from 'ionicons';
import {
  carSportOutline,
  constructOutline,
  personCircleOutline,
  logOutOutline,
  mailOutline,
  lockClosedOutline,
  qrCodeOutline,
  addCircleOutline,
  shieldCheckmarkOutline,
  checkmarkCircle,
  refreshOutline,
  cloudOfflineOutline,
  storefrontOutline,
  personAddOutline,
  personOutline,
  peopleOutline,
  shareSocialOutline,
  copyOutline,
  logoWhatsapp,
  trashOutline,
  createOutline,
  mailOpenOutline,
  alertCircleOutline,
  cameraOutline,
  documentAttachOutline,
  documentTextOutline,
  timeOutline,
  speedometerOutline,
  calendarOutline,
  checkmarkCircleOutline,
  chevronDown,
  chevronForward,
  notificationsOutline,
  homeOutline,
  searchOutline,
  locationOutline,
  locateOutline,
  callOutline,
  navigateOutline,
  star,
  starOutline,
  eyeOutline,
  waterOutline,
  funnelOutline,
  cogOutline,
  batteryHalfOutline,
  apertureOutline,
  discOutline,
  flashOutline,
  thermometerOutline,
  close,
  chevronBack,
  warningOutline,
  informationCircleOutline,
  chevronUp,
  swapHorizontalOutline,
  hourglassOutline,
  gridOutline,
  mapOutline,
  contrastOutline,
  swapVerticalOutline,
  checkmark,
  ellipsisHorizontal,
  businessOutline,
  shareOutline,
  closeCircle,
  addOutline,
  listOutline,
} from 'ionicons/icons';

/**
 * Ícones próprios das linhas de veículo (o ionicons não tem caminhão nem trator).
 * Mesmo traço dos ícones "outline" (stroke em currentColor), desenhados na grade de 24 px.
 */
const svg = (paths) => `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
const TC_ICONS = {
  'tc-car': svg('<path d="M3 13l2-5.5A2 2 0 0 1 6.9 6h10.2a2 2 0 0 1 1.9 1.5L21 13v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM3 13h18"/><circle cx="7.5" cy="15.5" r=".8"/><circle cx="16.5" cy="15.5" r=".8"/>'),
  'tc-truck': svg('<path d="M2 6h11v10H2zM13 9h4.5l3.5 3.5V16h-8"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>'),
  'tc-tractor': svg('<circle cx="7" cy="16" r="4"/><circle cx="18.5" cy="17.5" r="2.5"/><path d="M4.5 12.5V6h6.5l2 6.5H19v2.8M8 6V3.5"/>'),
  'tc-hourmeter': svg('<path d="M7 3h10M7 21h10M8 3v3a4 4 0 0 0 8 0V3M8 21v-3a4 4 0 0 1 8 0v3"/>'),
  'tc-qr': svg('<path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2M14 18h2M18 18h2v2"/>'),
  'tc-wrench': svg('<path d="M14.7 6.3a4 4 0 0 0-5.4 5.1L3 17.7 6.3 21l6.3-6.3a4 4 0 0 0 5.1-5.4l-2.6 2.6-2.4-.6-.6-2.4z"/>'),
  'tc-garage': svg('<path d="M3 10 12 4l9 6v10H3zM7 20v-6h10v6M7 17h10"/>'),
};

import { defineCustomElement as ionApp } from '@ionic/core/components/ion-app.js';
import { defineCustomElement as ionRouter } from '@ionic/core/components/ion-router.js';
import { defineCustomElement as ionRoute } from '@ionic/core/components/ion-route.js';
import { defineCustomElement as ionRouterOutlet } from '@ionic/core/components/ion-router-outlet.js';
import { defineCustomElement as ionHeader } from '@ionic/core/components/ion-header.js';
import { defineCustomElement as ionToolbar } from '@ionic/core/components/ion-toolbar.js';
import { defineCustomElement as ionTitle } from '@ionic/core/components/ion-title.js';
import { defineCustomElement as ionContent } from '@ionic/core/components/ion-content.js';
import { defineCustomElement as ionFooter } from '@ionic/core/components/ion-footer.js';
import { defineCustomElement as ionButtons } from '@ionic/core/components/ion-buttons.js';
import { defineCustomElement as ionButton } from '@ionic/core/components/ion-button.js';
import { defineCustomElement as ionBackButton } from '@ionic/core/components/ion-back-button.js';
import { defineCustomElement as ionInput } from '@ionic/core/components/ion-input.js';
import { defineCustomElement as ionInputPasswordToggle } from '@ionic/core/components/ion-input-password-toggle.js';
import { defineCustomElement as ionList } from '@ionic/core/components/ion-list.js';
import { defineCustomElement as ionListHeader } from '@ionic/core/components/ion-list-header.js';
import { defineCustomElement as ionItem } from '@ionic/core/components/ion-item.js';
import { defineCustomElement as ionLabel } from '@ionic/core/components/ion-label.js';
import { defineCustomElement as ionNote } from '@ionic/core/components/ion-note.js';
import { defineCustomElement as ionText } from '@ionic/core/components/ion-text.js';
import { defineCustomElement as ionIcon } from '@ionic/core/components/ion-icon.js';
import { defineCustomElement as ionChip } from '@ionic/core/components/ion-chip.js';
import { defineCustomElement as ionCard } from '@ionic/core/components/ion-card.js';
import { defineCustomElement as ionCardHeader } from '@ionic/core/components/ion-card-header.js';
import { defineCustomElement as ionCardTitle } from '@ionic/core/components/ion-card-title.js';
import { defineCustomElement as ionCardSubtitle } from '@ionic/core/components/ion-card-subtitle.js';
import { defineCustomElement as ionCardContent } from '@ionic/core/components/ion-card-content.js';
import { defineCustomElement as ionRefresher } from '@ionic/core/components/ion-refresher.js';
import { defineCustomElement as ionRefresherContent } from '@ionic/core/components/ion-refresher-content.js';
import { defineCustomElement as ionSpinner } from '@ionic/core/components/ion-spinner.js';
import { defineCustomElement as ionToast } from '@ionic/core/components/ion-toast.js';
import { defineCustomElement as ionLoading } from '@ionic/core/components/ion-loading.js';
import { defineCustomElement as ionAlert } from '@ionic/core/components/ion-alert.js';
import { defineCustomElement as ionProgressBar } from '@ionic/core/components/ion-progress-bar.js';
import { defineCustomElement as ionTextarea } from '@ionic/core/components/ion-textarea.js';
import { defineCustomElement as ionSelect } from '@ionic/core/components/ion-select.js';
import { defineCustomElement as ionSelectOption } from '@ionic/core/components/ion-select-option.js';
import { defineCustomElement as ionRadio } from '@ionic/core/components/ion-radio.js';
import { defineCustomElement as ionRadioGroup } from '@ionic/core/components/ion-radio-group.js';

export function setupIonic() {
  initialize({
    // Mantém o comportamento nativo de cada plataforma (iOS/Material).
    innerHTMLTemplatesEnabled: false,
  });

  for (const define of [
    ionApp, ionRouter, ionRoute, ionRouterOutlet,
    ionHeader, ionToolbar, ionTitle, ionContent, ionFooter,
    ionButtons, ionButton, ionBackButton,
    ionInput, ionInputPasswordToggle,
    ionList, ionListHeader, ionItem, ionLabel, ionNote, ionText,
    ionIcon, ionChip,
    ionCard, ionCardHeader, ionCardTitle, ionCardSubtitle, ionCardContent,
    ionRefresher, ionRefresherContent, ionSpinner,
    ionToast, ionLoading, ionAlert, ionProgressBar, ionTextarea,
    ionSelect, ionSelectOption, ionRadio, ionRadioGroup,
  ]) {
    define();
  }

  addIcons({
    ...TC_ICONS,
    'grid-outline': gridOutline,
    'map-outline': mapOutline,
    'contrast-outline': contrastOutline,
    'swap-vertical-outline': swapVerticalOutline,
    checkmark,
    'ellipsis-horizontal': ellipsisHorizontal,
    'business-outline': businessOutline,
    'share-outline': shareOutline,
    'close-circle': closeCircle,
    'add-outline': addOutline,
    'list-outline': listOutline,
    'information-circle-outline': informationCircleOutline,
    'chevron-up': chevronUp,
    'swap-horizontal-outline': swapHorizontalOutline,
    'hourglass-outline': hourglassOutline,
    'car-sport-outline': carSportOutline,
    'construct-outline': constructOutline,
    'person-circle-outline': personCircleOutline,
    'log-out-outline': logOutOutline,
    'mail-outline': mailOutline,
    'lock-closed-outline': lockClosedOutline,
    'qr-code-outline': qrCodeOutline,
    'add-circle-outline': addCircleOutline,
    'shield-checkmark-outline': shieldCheckmarkOutline,
    'checkmark-circle': checkmarkCircle,
    'refresh-outline': refreshOutline,
    'cloud-offline-outline': cloudOfflineOutline,
    'storefront-outline': storefrontOutline,
    'person-add-outline': personAddOutline,
    'person-outline': personOutline,
    'people-outline': peopleOutline,
    'share-social-outline': shareSocialOutline,
    'copy-outline': copyOutline,
    'logo-whatsapp': logoWhatsapp,
    'trash-outline': trashOutline,
    'create-outline': createOutline,
    'mail-open-outline': mailOpenOutline,
    'alert-circle-outline': alertCircleOutline,
    'camera-outline': cameraOutline,
    'document-attach-outline': documentAttachOutline,
    'document-text-outline': documentTextOutline,
    'time-outline': timeOutline,
    'speedometer-outline': speedometerOutline,
    'calendar-outline': calendarOutline,
    'checkmark-circle-outline': checkmarkCircleOutline,
    'chevron-down': chevronDown,
    'chevron-forward': chevronForward,
    'notifications-outline': notificationsOutline,
    'home-outline': homeOutline,
    'search-outline': searchOutline,
    'location-outline': locationOutline,
    'locate-outline': locateOutline,
    'call-outline': callOutline,
    'navigate-outline': navigateOutline,
    star,
    'star-outline': starOutline,
    'eye-outline': eyeOutline,
    'water-outline': waterOutline,
    'funnel-outline': funnelOutline,
    'cog-outline': cogOutline,
    'battery-half-outline': batteryHalfOutline,
    'aperture-outline': apertureOutline,
    'disc-outline': discOutline,
    'flash-outline': flashOutline,
    'thermometer-outline': thermometerOutline,
    close,
    'chevron-back': chevronBack,
    'warning-outline': warningOutline,
  });
}
